import { Acc } from '../../../../components/edit-object/design/Accordion';
import { Field } from '../../../../components/edit-object/design/Field';
import { Textarea } from '../../../../components/edit-object/design/Form';
import type { ArtworkDetailsForm } from '../useArtworkDetailsForm';

interface Props {
  form: ArtworkDetailsForm;
}

export const AdditionalNotesSection = ({ form }: Props) => {
  const { notes, setNotes } = form;
  const trimmed = notes.trim().replace(/\s+/g, ' ');
  const summary = trimmed.length > 60 ? `${trimmed.slice(0, 60)}…` : trimmed || '';

  return (
    <Acc
      id="sec-notes"
      title="Additional Notes"
      summary={summary}
      emptyPlaceholder="No notes added"
    >
      <Field label="Notes about this artwork">
        <Textarea
          id="notes-public"
          rows={5}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Concept, inspiration, process, materials story, or anything else worth recording publicly about this work…"
        />
      </Field>
      <div className="helper-row">
        These notes are part of the public catalog entry. For private-only notes,
        see <strong>Always Private</strong> in the sidebar.
      </div>
    </Acc>
  );
};
